import { createClient } from '@supabase/supabase-js';
const supabaseUrl = 'https://djqgousrgxxxbxccbxrz.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRqcWdvdXNyZ3h4eGJ4Y2NieHJ6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjY0MTU0NjEsImV4cCI6MjA4MTk5MTQ2MX0.A4V1DPQRXQxlrZbqJ57C5XmJ4NshqCRlwuvMPlJzlHU';
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
